import Axios from "axios";
import {
  fetchCollageUserFeePaymentSlipUrl,
  getCollegeUserPaymentSlipDetails,
  clgUserFeeStatementPdfUrl
} from "../../../api";
import {
  saveMsg,
  updateMsg,
  deleteMsg,
  failedMsg,
  sessionExpireMsg
} from "../../../erpUtil";
import {
  SET_COLLEGE_USER_PAYSLIP_DETAILS,
  UNSET_COLLEGE_USER_PAYSLIP_DETAILS,
  SET_FEE_PAYMENT_SLIP,
  UNSET_FEE_PAYMENT_SLIP
} from "../../../mutation-types";
const state = {
  payment_slip_details: [],
  fee_statement: []
};
const getters = {
  getCollegeUserPaymentSlipDetails(state) {
    return state.payment_slip_details;
  },
  getFeePaymentSlip(state) {
    return state.fee_statement;
  }
};
const mutations = {
  [SET_COLLEGE_USER_PAYSLIP_DETAILS](state, data) {
    state.payment_slip_details = data;
  },
  [UNSET_COLLEGE_USER_PAYSLIP_DETAILS](state) {
    state.payment_slip_details = [];
  },
  [SET_FEE_PAYMENT_SLIP](state, data) {
    return (state.fee_statement = data);
  },
  [UNSET_FEE_PAYMENT_SLIP](state) {
    return (state.fee_statement = []);
  }
};
const actions = {
  fetchPaymentSlip({ commit, state }, data) {
    commit("SET_LOADING", { color: "primary" });
    var params = new URLSearchParams();
    return new Promise((resolve, reject) => {
      Axios.get(fetchCollageUserFeePaymentSlipUrl, data)
        .then(response => {
          commit("SET_FEE_PAYMENT_SLIP", response.data.data);
          if (response.data.code == 200) {
            // commit("SET_SNACKBAR", { msg: saveMsg, color: "green" });
            resolve();
          } else {
            commit("SET_SNACKBAR", {
              msg: failedMsg,
              color: "red"
            });
            reject();
          }
        })
        .catch(error => {
          commit("UNSET_FEE_PAYMENT_SLIP");
          commit("SET_SNACKBAR", {
            msg: failedMsg,
            color: "red"
          });
          reject();
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },
  getCollegeUserPaymentSlipDetails({ commit, state }, data) {
    commit("SET_LOADING", { color: "primary" });
    var params = new URLSearchParams();
    return new Promise((resolve, reject) => {
      Axios.get(getCollegeUserPaymentSlipDetails, data)
        .then(response => {
          let result = response.data.data;

          commit("SET_COLLEGE_USER_PAYSLIP_DETAILS", result);
        })
        .catch(error => {
          commit("UNSET_COLLEGE_USER_PAYSLIP_DETAILS");
          commit("SET_SNACKBAR", {
            msg: failedMsg,
            color: "red"
          });
          reject();
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },
  clgUserFeeStatementPdf({ commit, state }, data) {
    commit("SET_LOADING", {
      color: "primary"
    });
    let url = `${clgUserFeeStatementPdfUrl}`;
    return new Promise((resolve, reject) => {
      Axios.get(url, data).then(response => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "fee_statement.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
      commit("UNSET_LOADING");
    });
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
